<template>
  <div>
    <div class="container">
      <div style="text-align: center">
        <div style="box-sizing: border-box; position: relative; font-size: 0">
          <img v-if="avatarFrameIndex!==null && avatarFrameList[avatarFrameIndex].avatarFrameUrl"
               :src="avatarFrameList[avatarFrameIndex].avatarFrameUrl" width="120px"
               height="120px" class="avatarFrameImage"/>
          <img :src="avatar" class="avatar" @click="Preview"/>
        </div>
        <div v-if=avatarFrameList[avatarFrameIndex] style="padding-top: 20px">
          {{ avatarFrameList[avatarFrameIndex].name }}
        </div>
      </div>
    </div>
    <div style="display: flex;justify-content: space-around;margin-top: 10px">
      <van-button type="primary" @click="updateAvatar">
        修改头像
      </van-button>
      <van-button type="info" @click="saveAvatarFrame">
        保存头像框
      </van-button>

    </div>
    <div style="display: flex;flex-wrap: wrap;margin-top: 10px">
      <div v-for="(frame,index) in avatarFrameList" :key="index" style="flex-basis: 50%">
        <div class="item"
             :class="{active: avatarFrameIndex === index}"
             @click="avatarFrameIndex = index">
          <div v-if="frame.logId" style="text-align: center;height: 121px">
            <img :src="frame.avatarFrameUrl" style="width: 80px;height: 80px"/>
            <div>{{frame.name}}</div>
            <div>
              <template v-if="frame.expireTime">
                <span>{{formatDate(frame.obtainTime,'YYYY/MM/DD')}} 至 {{formatDate(frame.expireTime,'YYYY/MM/DD')}}</span>
                <span v-if="frame.expireTime < new Date().getTime()">（已过期）</span>
              </template>
              <span v-else>永久</span>
            </div>
          </div>
          <div v-else style="height: 121px;display: flex;justify-content: center;align-items: center">
            无
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import {Button, Dialog, ImagePreview, Toast} from "vant";
import {wx, wxConfig} from "@/libs/jssdk-util";
import {updateAvatar} from '@/api/clerk/clerk'
import {handlePromise} from "@/libs/util";
import {listClerkAvatarFrame, saveClerkAvatarFrame} from "@/api/clerk/avatar_frame";

Vue.use(Dialog)
    .use(ImagePreview)
    .use(Button)
    .use(Toast)


export default {
  name: "updateAvatarUrl",
  data() {
    return {
      avatar: '',
      avatarFrameIndex: null,
      avatarFrameLogId: null,
      avatarFrameList: [],
    }
  },

  methods: {
    prev() {
      if (this.avatarFrameIndex > 0) {
        this.avatarFrameIndex--;
      } else {
        this.avatarFrameIndex = this.avatarFrameList.length - 1
      }
    },
    next() {
      this.avatarFrameIndex = (this.avatarFrameIndex + 1) % this.avatarFrameList.length
    },
    loadData() {
      Toast.loading()
      handlePromise(listClerkAvatarFrame(), (data) => {
        Toast.clear()
        this.avatarFrameLogId = data.avatarFrameLogId
        this.avatarFrameList = data.avatarFrameList
        this.avatarFrameList.unshift({logId: null, name: '无', avatarFrameUrl: null})
        for (let i in this.avatarFrameList) {
          if (this.avatarFrameLogId === this.avatarFrameList[i].logId) {
            this.avatarFrameIndex = Number(i)
          }
        }
      })
    },
    Preview() {
      let Preview = []
      Preview[0] = this.avatar
      ImagePreview({
        images: Preview
      })
    },
    saveAvatarFrame() {
      Toast.loading()
      handlePromise(saveClerkAvatarFrame(this.avatarFrameList[this.avatarFrameIndex].logId), () => {
        Toast.clear()
        Toast.success('操作成功')
      })
    },

    base64ImageSize(base64ImageStr) {
      const indexBase64 = base64ImageStr.indexOf('base64,');
      if (indexBase64 < 0) return -1;
      const str = base64ImageStr.substr(indexBase64 + 6);
      return (str.length * 0.75 / 1024 / 1024).toFixed(2);
    },

    updateAvatar() {
      let that = this
      wx.chooseImage({//选择图片
        count: 1,
        sizeType: ['compressed','original'], // 可以指定是原图还是压缩图，默认二者都有
        success: function (res) {
          console.log('选择的图片:', res)
          let localIds = res.localIds
          // window.__wxjs_is_wkwebview  判断ios机型
          wx.getLocalImgData({
            localId: localIds[0],
            success: (res3) => {
              Toast.loading({
                mask: true,
                message: '上传头像中'
              })
              let localData = res3.localData

              // localData = localData.replace('jgp', 'jpeg');//iOS 系统里面得到的数据，类型为 image/jgp,因此需要替换一下
              if (localData.indexOf('data:image') == 0) {
              } else { //ios返回完整的base64, 安卓返回的没有头部 且其中可能包含换行符
                localData = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
              }
              let size = that.base64ImageSize(localData)
              if(size > 1){
                return Toast('图片不得大于1MB');
              }

              updateAvatar(localData.split(',')[1]).then(res => {
                Toast.clear()
                const data = res.data;
                if (data.code == 0) {
                  Dialog.alert({
                    title: '提交成功'
                  }).then(() => {
                    that.$router.back(-1)
                  })
                } else {
                  Dialog.alert({
                    title: '修改头像失败',
                    message: data.msg
                  }).then(() => {
                    that.$router.back(-1)
                  })
                }
              })
            }
          })
        },

        fail(err) {
          Dialog.alert({
            title: '打开相册失败',
            message: err.errMsg
          })
        }
      })
    },
  },

  mounted() {
    this.loadData()
    this.avatar = JSON.parse(this.$route.query.url)

    wxConfig(['chooseImage', 'previewImage', 'getLocalImgData'])
    wx.error(function (err) {
      Dialog.alert({
        title: '微信配置失败，请刷新页面',
        message: JSON.stringify(err)
      })
    });

  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 50px 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .avatar {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    object-fit: cover;
  }

  .avatarFrameImage{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.editAvatar {
  margin-top: 40px;
  background-color: #07c160;
  text-align: center;
  width: 100%;
  height: 45px;
  line-height: 45px;
  font-size: 15px;
  color: #fff;
  font-weight: bold;
}

.item {
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid lightgrey
}

.active {
  border: 1px solid gold;
}
</style>
